import {
  AssetCheckException,
  AssetCveException,
  SpaceAdvisoryException,
} from "~/pages/findings/Exceptions/types";
import { Asset } from "~/pages/inventory/asset/types";
import {
  ExceptionFindingsTableException,
  ExceptionFindingsTableScope,
  ExceptionFindingTableType,
} from "./exceptionFindigsTableTypes";
import {
  getAssetDetailUrl,
  getCheckDetailUrl,
  getCveDetailUrl,
  getSpaceAdvisoryDetailUrl,
} from "~/lib/urlUtils";
import { FirewatchColumnProps } from "~/components/FirewatchPage/FirewatchPageColumns";

const COLUMNS: FirewatchColumnProps = {
  Impact: {
    id: "IMPACT",
    field: "RISK_VALUE",
    label: "Risk",
    options: { width: 130 },
  },
  Vulnerability: {
    id: "VULNERABILITY",
    field: "TITLE",
    label: "Vulnerability",
  },
  Asset: {
    id: "ASSET",
    field: "TITLE",
    label: "Asset",
  },
  Advisory: {
    id: "ADVISORY",
    field: "TITLE",
    label: "Advisory",
  },
  Check: { id: "CHECK", field: "TITLE", label: "Check" },
  Finding: { id: "FINDING", field: "TITLE", label: "Finding" },
  RiskFactors: {
    id: "RISK_FACTORS",
    field: "RISK_FACTORS",
    label: "Risk factors",
    options: { sx: { width: "20%" } },
  },
};

export function getHeaders(exceptionType: ExceptionFindingTableType) {
  if (exceptionType === "advisory") {
    return [COLUMNS.Impact, COLUMNS.Vulnerability, COLUMNS.RiskFactors];
  }
  if (exceptionType === "cve") {
    return [COLUMNS.Impact, COLUMNS.Vulnerability, COLUMNS.RiskFactors];
  }
  if (exceptionType === "check") {
    return [COLUMNS.Impact, COLUMNS.Check, COLUMNS.RiskFactors];
  }
  if (exceptionType === "fex") {
    return [COLUMNS.Impact, COLUMNS.Finding, COLUMNS.RiskFactors];
  }
  return [COLUMNS.Impact, COLUMNS.Asset, COLUMNS.RiskFactors];
}

export function getRowUrl(
  findingType: ExceptionFindingTableType,
  scope: ExceptionFindingsTableScope,
  exception: ExceptionFindingsTableException,
  contextProps: { spaceId?: string; assetId?: string },
): string {
  if (findingType === "advisory") {
    return getSpaceAdvisoryDetailUrl({
      advisoryId: (exception as SpaceAdvisoryException).id,
      spaceId: contextProps.spaceId!,
    });
  }

  if (findingType === "cve") {
    return getCveDetailUrl({
      scope,
      cveId: (exception as AssetCveException).id,
      spaceId: contextProps.spaceId!,
      assetId: contextProps.assetId,
    });
  }

  if (findingType === "check") {
    return getCheckDetailUrl({
      scope,
      checkMrn: (exception as AssetCheckException).mrn,
      spaceId: contextProps.spaceId!,
      assetId: contextProps.assetId,
    });
  }

  if (findingType === "fex") {
    return "#";
  }

  if (findingType === "asset") {
    return getAssetDetailUrl({
      assetId: (exception as Asset).id,
      spaceId: contextProps.spaceId!,
    });
  }

  return "#";
}
